const styles = {
    SIGNUP_CONTAINER: {
        border: '1px solid #a2a2a2',
        borderRadius: '16px',
        padding: '1.5rem'
    },
    CONTAINER: {
        backgroundImage: 'url("https://www.app.linkplease.co/assests/bg.svg")',
        backgroundSize: 'cover',
        backgroundAttachment: 'fixed',
        // minHeight: '100vh',
        width: '100%'
    }
}

export default styles